export const beneficios_services = {
  get_all: { method: "get", url: "api/oportunidades-beneficios" },
  show: { method: "get", url: "api/oportunidades-beneficios{/id}" },
  store: { method: "post", url: "api/oportunidades-beneficios" },
  update: { method: "put", url: "api/oportunidades-beneficios{/id}" },
  delete: { method: "delete", url: "api/oportunidades-beneficios{/id}" },
};

export const beneficios_concedentes_services = {
  get_all: { method: "get", url: "api/oportunidades-ben-concedentes" },
  show: { method: "get", url: "api/oportunidades-ben-concedentes{/id}" },
  store: { method: "post", url: "api/oportunidades-ben-concedentes" },
  update: {
    method: "put",
    url: "api/oportunidades-ben-concedentes{/id}",
  },
  delete: {
    method: "delete",
    url: "api/oportunidades-ben-concedentes{/id}",
  },
};

export const emendas_services = {
  get_all: { method: "get", url: "api/oportunidades-emendas" },
  show: { method: "get", url: "api/oportunidades-emendas{/id}" },
  store: { method: "post", url: "api/oportunidades-emendas" },
  update: { method: "put", url: "api/oportunidades-emendas{/id}" },
  delete: { method: "delete", url: "api/oportunidades-emendas{/id}" },
};

export default {
  get_all: { method: "get", url: "api/oportunidades" },
  list: { method: "get", url: "api/oportunidades/list" },
  show: { method: "get", url: "api/oportunidades{/id}" },
  store: { method: "post", url: "api/oportunidades" },
  update: { method: "put", url: "api/oportunidades{/id}" },
  delete: { method: "delete", url: "api/oportunidades{/id}" },
  currencies: { method: "get", url: "api/moedas" },
  get_ods: { method: "get", url: "api/oportunidades/ods" },
  get_model_municipios: {
    method: "get",
    url: "api/oportunidades/municipios/modelo",
    responseType: "blob",
  },
  get_base_municipios: {
    method: "get",
    url: "api/oportunidades/{id}/municipios/exportar",
    responseType: "blob",
  },
  update_municipios: {
    url: "api/oportunidades/{id}/municipios/importar",
    method: "post",
  },
  status_update_municipios: {
    url: "api/oportunidades/{id}/municipios/importacao/{importacaoId}",
    method: "get",
  },
  estatisticas_valores: {
    method: "get",
    url: "api/oportunidades/estatisticas-valores{/id}",
  },
  importar_emendas: {
    method: "post",
    url: "api/oportunidades/importar-emendas",
  },
  validar_emendas: {
    method: "post",
    url: "api/oportunidades/validar-emendas",
  },
  get_tipos_instrumentos: {
    method: "get",
    url: "api/tipos-instrumentos/to-select",
  },
  get_all_editais: {
    method: "get",
    url: "api/editais",
  },
  get_plataformas: {
    method: "get",
    url: "api/plataformas/to-select",
  },
};
